module.exports = __webpack_public_path__ + "static/media/ilustracion1.b47d9772.png";